var ur = window.location.href;

jQuery(document).ready(function(){

  

jQuery('button#AddToCart-product-template').click(function(){
    if($('.vwo-cart-test').length == 0){
      
jQuery('body').addClass('conv-redirect');
  
  var x = 0;
var cTimer = setInterval(function(){
  if(jQuery('.slidecarthq-overlay.open').length) {
	window.location.href = '/cart';
     clearInterval(cTimer);
  }
x++;
}, 50);
    }
}); 


jQuery('[href="/cart"]').click(function(e){
      if(jQuery('.vwo-cart-test').length == 0){
  e.preventDefault();
        console.log('hercart');
jQuery('body').addClass('conv-redirect');
	window.location.href = '/cart';
      }
});     
  
  
  
  
});     




var ur = window.location.href;

if(ur.includes('black-friday-cyber-monday-2023')){
  jQuery(document).ready(function(){
$('[href="#p1"]').click(function(){
  
  var hr = "div#shopify-section-template--16258986148011__2af2e2b4-6bdc-4a53-a096-ee622ed93c55";
  var elementToScrollTo = document.querySelectorAll(hr)[0];
  var offset = 100; // Adjust this value based on your requirements

// Scroll to the element with an offset
elementToScrollTo.scroll({
  top: elementToScrollTo.offsetTop - offset,
  behavior: 'smooth',
  block: 'start'
});
}); 
$('[href="#p2"]').click(function(){
  
  var hr = ".rich-text.px-rail.py-section.border-b.border-primary-section-border.text-align-section";
  var elementToScrollTo = document.querySelectorAll(hr)[0];
    elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
}); 
$('[href="#p3"]').click(function(){
  
  var hr = "div#shopify-section-template--16258986148011__2af2e2b4-6bdc-4a53-a096-ee622ed93c55";
  var elementToScrollTo = document.querySelectorAll(hr)[0];
    elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
});
$('[href="#p4"]').click(function(){
  
  var hr = "div#shopify-section-template--16258986148011__2af2e2b4-6bdc-4a53-a096-ee622ed93c55";
  var elementToScrollTo = document.querySelectorAll(hr)[0];
    elementToScrollTo.scrollIntoView({ behavior: 'smooth' });
});     
});
}



var ur = window.location.href;
if(ur.includes('/product')){
 setInterval(function(){ 
    if($('.bpz-selector option:selected').eq(0).attr('disabled') || $('.bpz-selector option:selected').eq(1).attr('disabled')){

    }
    else{
   if($("#ProductSelect-product-template option:selected").attr('data-lead-time')){
     $('.lead-time').html($("#ProductSelect-product-template option:selected").attr('data-lead-time'));
   }
   else{
     $('.lead-time').html($("#product-lead-time").html());
   }
    }

}, 100);

  
  jQuery(document).ready(function(){
   jQuery('div#tab-1 a').removeAttr('href');
   jQuery('div#tab-1 a').addClass('no-links');
if($('[data-lead-time]').attr('data-lead-time') != ""){

    var leadTimes = $('.lead-time').html()
    $('div#tab-1').eq(0).prepend($('<div class="lead-time-tab">'+leadTimes+'</div>'));
  $('.bpz-selector').change(function(){
     setTimeout(function(){ 
 var leadTimes = $('.lead-time').html()
   $('.lead-time-tab').eq(0).html(leadTimes)
}, 500);
   

  
}); 
}
});
}

jQuery(document).ready(function(){
if(jQuery('body').hasClass('template-index')){

 var fff = 0; var timerfff = setInterval(function(){
  if(jQuery('div#homepage-trustpilot').length) {
    jQuery('div#homepage-trustpilot').closest('.featured-text-section').addClass('trustpilot-section');	
clearInterval(timerfff);}if( fff > 200){clearInterval(timerfff);}fff++;}, 50);
 
 setTimeout(function(){ 
window.dispatchEvent(new Event('resize'));
}, 2000);

}
});
var ur = window.location.href;
if(ur.includes('/protectvest')){
  jQuery(document).ready(function(){
jQuery('#bpz-close').click(function(){
  jQuery('div#bpz-popup-section').hide();
}); 
});
}


jQuery(document).ready(function(){
 setTimeout(function(){ 
var rev = "1000+";
   $('span.badge1 b').eq(0).html(rev);
}, 100);
});

var ur = window.location.href;
if(ur.includes('/protectvest')){
 jQuery(document).ready(function(){
   
   $('.bpz-popup .bpz-buyNow').click(function(e){
      if($('.bpz-selector option:selected').eq(0).attr('disabled') || $('.bpz-selector option:selected').eq(1).attr('disabled')){
                                        
                                              
                                          }
    else{
    e.preventDefault();

    var qty = $('input#Quantity-product-template').val();

    var checkoutLink = 'https://bulletproofzone.com/cart/41466167165099:' + qty + '?checkout';

    window.location.href = checkoutLink;
    }
	}); 
     
   
   $('.bpz-popup  button#AddToCart-product-template').click(function(e){
     e.preventDefault();

    var qty = $('input#Quantity-product-template').val();

    var carLink = 'https://bulletproofzone.com/cart/add?id=41466167165099&quantity=' + qty ;

    window.location.href = carLink;
     
	}); 
        
   
     
     
   function quickView(){
    $('div#bpz-popup-section').show();
     $('')
   }
   $('.bpz-popup button.adjust.adjust-plus').click(function(e){
     e.preventDefault();
     e.stopImmediatePropagation();
     var q =  parseInt($('input#Quantity-product-template').val());
      $('input#Quantity-product-template').val( q + 1);
  
}); 
   
   $('.bpz-popup button.adjust.adjust-minus').click(function(e){
     e.preventDefault();
     e.stopImmediatePropagation();
     var q =  parseInt($('input#Quantity-product-template').val());
     if(q > 1){
      $('input#Quantity-product-template').val( q- 1);
     }
  
}); 
   
   
$('div#pv-hero').click(function(e){
  if(window.innerWidth < 768){
    
  e.stopImmediatePropagation();
  e.stopPropagation();
  e.preventDefault();
  quickView()
  }
}); 
$('[data-pf-type="Button"]').click(function(e){
  e.stopImmediatePropagation();
  e.stopPropagation();
  e.preventDefault();
  quickView()
}); 
}); 
}


var tt = 0; var timertt = setInterval(function(){
  var s = jQuery('div.collection-list .box figure img').eq(0).attr('srcset');
  if(jQuery('div.collection-list .box figure img') != null && jQuery('div.collection-list .box figure img').length && jQuery('body').hasClass('template-index')) {
    var images = ['https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Bulletproof_Vests.jpg?v=1650710951',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Plate_Carriers.jpg?v=1650710951',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Armor_Plates.jpg?v=1650710951',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Ballistic_Helmets.jpg?v=1650710951',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Body_armor_packages.jpg?v=1650710951',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Bulletproof_Clothing.jpg?v=1650710951',
                  'https://cdn.shopify.com/s/files/1/1926/7025/files/Bulletproof_Backpacks2-20.jpg?v=1651045975',
                 'https://cdn.shopify.com/s/files/1/1926/7025/files/VWO-Other_gear.jpg?v=1650710951']
    
     var imgs = jQuery('div.collection-list .box figure img');
  for(var i = 0; i < imgs.length; i++){
    imgs.eq(i).attr('srcset', images[i]);
    imgs.eq(i).attr('src', images[i]);   
    
  }	
   
;}if( tt > 100){clearInterval(timertt);}tt++;}, 50);



var ur = window.location.href;
if(ur.includes('/pages/protect-vest-copy')){
}

jQuery('head').append('<link rel="stylesheet" class="external-css-link" type="text/css" href="https://fonts.googleapis.com/css?family=Bai%20Jamjuree:200,400,500,700,900">');
 var ur = window.location.href;
if(ur.includes('/product')){
var addd = 0; var timeraddd = setInterval(function(){
  if(jQuery('button#AddToCart-product-template').length) {
    if(jQuery('.bpz-buyNow').length == 0){
     jQuery('button#AddToCart-product-template').eq(0).after(jQuery('<div class="bpz-buyNow">BUY NOW</div>'));
      
         jQuery('.trust-badges-cont').before(jQuery('<div class="lead-times-anchor">SEE BELOW FOR PRODUCT DETAILS AND LEAD TIMES <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="12" fill="white" stroke="#DE5101" stroke-width="2"></circle><path d="M17.875 9.27062L16.7294 8.125L13 11.8463L9.27062 8.125L8.125 9.27062L13 14.1456L17.875 9.27062Z" fill="#DE5101"></path><path d="M17.875 14.625L16.7294 13.4794L13 17.2006L9.27062 13.4794L8.125 14.625L13 19.5L17.875 14.625Z" fill="#DE5101"></path></svg></div>'));
      jQuery('.single-product .grid aside.product-aside').eq(0).append(jQuery('.trust-badges-cont').eq(0));
      $('.lead-times-anchor').click(function(){
  $('html, body').animate({
        scrollTop: $('ul.tabs').offset().top - 200
    }, 100);
}); 
      
       $('span.stamped-badge-caption').click(function(e){
         e.stopPropagation();
         e.preventDefault();
  $('html, body').animate({
        scrollTop: $('.stamped-header-title').offset().top - 140
    }, 100);
}); 
 }
  jQuery('.bpz-buyNow').click(function(){
    // Direct checkout — get variant ID and redirect to checkout
    var form = jQuery('form[action*="/cart/add"]').eq(0);
    if (form.length) {
      var variantId = form.find('select[name="id"], input[name="id"]').val();
      var qty = jQuery('input#Quantity-product-template').val() || 1;
      if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + qty + '?checkout';
        return;
      }
    }
    jQuery('button#AddToCart-product-template').click();
  });
  
  Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = [`
<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.5" d="M22.2005 11.52L12.4805 22.08V49.32H50.6405L50.1449 21.12L39.8621 11.52H22.2005Z" fill="#DC5426"></path>
</g>
<path d="M51.4912 20.7312L40.9792 9.51355L19.1476 9.39355L8.50959 20.7312H8.40039V50.6112H51.6004V20.7312H51.4912ZM47.9908 20.7312H30.8404V11.8512L40.0228 11.904L47.9908 20.7312ZM20.0932 11.7936L28.4392 11.8416V20.7312H12.0088L20.0932 11.7936ZM49.2004 48.2112H10.8004V23.1312H49.2004V48.2112Z" fill="#050606"></path>
<path d="M22.6813 31.7748H24.4141L24.5521 30.9888H22.8193L23.0605 29.6136H25.2217L25.3669 28.7988H22.1797L21.2773 33.936H22.3033L22.6813 31.7748Z" fill="#050606"></path>
<path d="M26.1813 33.936L26.5305 31.9344H26.9817L27.8397 33.936H28.9749L28.0509 31.8841C28.438 31.8138 28.796 31.6315 29.0805 31.3596C29.3458 31.096 29.5203 30.7547 29.5785 30.3852C29.5989 30.2797 29.6089 30.1724 29.6085 30.0648C29.6152 29.8912 29.5826 29.7182 29.5132 29.5589C29.4438 29.3995 29.3394 29.2578 29.2077 29.1444C28.9357 28.9148 28.5381 28.8 28.0149 28.8H26.0577L25.1553 33.9384L26.1813 33.936ZM26.9385 29.664H27.7785C28.2785 29.664 28.5285 29.864 28.5285 30.264C28.5301 30.3276 28.5253 30.3911 28.5141 30.4536C28.4213 30.9736 28.0817 31.2332 27.4953 31.2324H26.6553L26.9385 29.664Z" fill="#050606"></path>
<path d="M32.8475 33.114H30.8099L31.0499 31.7316H32.8691L33.0083 30.9456H31.1963L31.4219 29.6136H33.4595L33.6047 28.7988H30.5411L29.6387 33.936H32.7023L32.8475 33.114Z" fill="#050606"></path>
<path d="M36.5236 33.936L36.6688 33.114H34.6312L34.8712 31.7316H36.6904L36.8284 30.9456H35.0164L35.2432 29.6136H37.2808L37.426 28.7988H34.3624L33.46 33.936H36.5236Z" fill="#050606"></path>
<path d="M46.7996 39.5712H33.5996V41.2512H46.7996V39.5712Z" fill="#050606"></path>
<path d="M46.7996 42.6912H33.5996V44.3712H46.7996V42.6912Z" fill="#050606"></path>
</svg>
`,  
`
<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.5" d="M31.4401 18.96L28.6801 29.04H16.0801L23.2801 34.68L20.0401 46.32L46.6801 27H34.4401L31.4401 18.96Z" fill="#DC5426"></path>
</g>
<g opacity="0.5">
<path opacity="0.5" d="M33.1201 39.96L36.8401 38.4L41.0401 46.2L33.1201 39.96Z" fill="#DC5426"></path>
</g>
<path d="M29.9996 40.71L16.814 50.2884L21.854 34.7892L8.66602 25.2096H24.9596L29.9996 9.71045L35.0396 25.2096H51.3332L32.0396 39.2244L29.9996 40.71ZM16.052 27.6096L24.6716 33.8724L21.38 44.0052L29.3 38.2536L43.9508 27.612H33.2912L29.9996 17.4768L26.7068 27.6096H16.052Z" fill="#050606"></path>
<path d="M39.0801 37.6572L36.7965 38.3988L38.6181 44.0052L33.0969 39.9936L31.0029 41.4384L43.1841 50.2896L39.0801 37.6572Z" fill="#050606"></path>
</svg>
`,`
<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.5" d="M44.9999 26.4H17.8799V49.32H44.9999V26.4Z" fill="#DC5426"></path>
</g>
<path d="M38.0396 22.92H23.1596V18.528C23.1596 16.7139 23.8802 14.9742 25.163 13.6914C26.4457 12.4087 28.1855 11.688 29.9996 11.688C31.8137 11.688 33.5534 12.4087 34.8362 13.6914C36.1189 14.9742 36.8396 16.7139 36.8396 18.528V20.3928H39.2396V18.5244C39.2396 16.0738 38.2661 13.7236 36.5332 11.9908C34.8004 10.2579 32.4502 9.28442 29.9996 9.28442C27.549 9.28442 25.1987 10.2579 23.4659 11.9908C21.7331 13.7236 20.7596 16.0738 20.7596 18.5244V22.92H13.7012V50.7144H38.6108V48.3144H16.1012V25.32H43.898V50.4456H46.298V22.92H38.0396Z" fill="#050606"></path>
<path d="M30.8401 42.408V37.5528C31.6754 37.3475 32.4066 36.8434 32.8956 36.1358C33.3846 35.4281 33.5975 34.5658 33.4942 33.7119C33.3908 32.8579 32.9782 32.0714 32.3344 31.5009C31.6907 30.9304 30.8603 30.6154 30.0001 30.6154C29.1399 30.6154 28.3095 30.9304 27.6657 31.5009C27.0219 32.0714 26.6094 32.8579 26.506 33.7119C26.4026 34.5658 26.6155 35.4281 27.1045 36.1358C27.5935 36.8434 28.3247 37.3475 29.1601 37.5528V42.408H30.8401ZM28.1605 34.1364C28.1602 33.7726 28.2679 33.4168 28.4699 33.1141C28.6719 32.8114 28.9591 32.5754 29.2953 32.436C29.6314 32.2966 30.0013 32.26 30.3582 32.3308C30.7152 32.4017 31.043 32.5768 31.3004 32.834C31.5578 33.0913 31.7332 33.419 31.8042 33.7759C31.8753 34.1328 31.839 34.5027 31.6998 34.8389C31.5606 35.1752 31.3248 35.4625 31.0222 35.6647C30.7197 35.8669 30.364 35.9748 30.0001 35.9748C29.5125 35.9745 29.0449 35.7808 28.7001 35.4361C28.3552 35.0914 28.1611 34.624 28.1605 34.1364Z" fill="#050606"></path>
</svg>
`,
              
`
<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.5" d="M45.1201 48.6H19.0801V14.4H45.1201V25.9512L49.6801 33.6L45.1201 33.4848V48.6Z" fill="#DC5426"></path>
</g>
<path d="M46.3202 50.5656H13.709V40.38H16.109V48.1656H43.9202V33.9492H46.3202V50.5656Z" fill="#050606"></path>
<path d="M16.109 25.8912H13.709V9.43445H46.3202V18.78H43.9202V11.8344H16.109V25.8912Z" fill="#050606"></path>
<path d="M52.133 36.1332H38.1074L45.1202 23.9868L52.133 36.1332ZM42.2642 33.7332H47.9762L45.1202 28.7868L42.2642 33.7332Z" fill="#050606"></path>
<path d="M14.88 36.06L7.86719 23.9136H21.8928L14.88 36.06ZM12.024 26.3136L14.88 31.26L17.736 26.3136H12.024Z" fill="#050606"></path>
</svg>
`];
var badgeTexts = ["Free Shipping on Orders Over <b>$100</b>",
                  "Over <b>800+</b> Reviews on Trustpilot",
                  "Secure Payments",
                 "Easy Returns"];
var container = document.createElement('div');
container.className = 'bulletproof-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'bulletproof-img-container';
var y = document.querySelectorAll('div#PaymentButtonContainer-product-template')[0];
if(document.getElementsByClassName('bulletproof-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="bulletproof-badge-container">' + imgSrcs[i] +  '<span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "bulletproof-badges-container";
           
    
}  
jQuery('.product-title h1').eq(0).before(jQuery('.purchase-box span.vendor').eq(0));
clearInterval(timeraddd);}if( addd > 200){clearInterval(timeraddd);}addd++;}, 50);
  
}




var ur = window.location.href;
if(ur.includes('/product')){
  /*** CODE FOR VERIFICATION ***/
var ur = window.location.href;
if (ur.includes("/products") && window.innerWidth > 768) {
var bb = 0; var timerbb = setInterval(function(){
  if(jQuery('.thumbnails-placement-below').length) {
         if(window.innerWidth > 768){
	  jQuery('.thumbnails-placement-below').eq(0).addClass('thumbnails-placement-side');
      jQuery('.thumbnails-placement-below').eq(0).removeClass('thumbnails-placement-below');
         }
clearInterval(timerbb);}if( bb > 200){clearInterval(timerbb);}bb++;}, 50);
    
          /*** CODE FOR SLIDER ***/
   /* Materia fix #A1 v6 (2026-04-14): restore spam-inject fallback.
      Preload in layout/theme.liquid covers the happy path; if that fails to
      render for any reason, this interval's inject-on-every-tick will load
      slick from CDN as a backup. Original behavior — battle-tested. */
   var timmerSlick =  setInterval(function(){
     if (jQuery('.slick-initialized').length==0) {
     
       var vert = true;
       if(window.innerWidth < 768){
         vert =false;
       }
  (function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));
// <![CDATA[
var cssId="myCss";if(!document.getElementById(cssId)){var head=document.getElementsByTagName("head")[0],link=document.createElement("link");link.id=cssId,link.rel="stylesheet",link.type="text/css",link.href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick.min.css",head.appendChild(link)}
// ]]><\/script>
       
         
              jQuery('#ProductThumbs-product-template').eq(0).slick({
              slidesToShow: 5,
              dots:false,
              centerMode: true,
               vertical: vert,
                infinate: false,
                 responsive: [
             
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
                
              }); 
       
         jQuery('body').addClass('slick-loaded');
       
    		}
       
      else
        {    
      
     clearInterval(timmerSlick);
        }
    }, 100);
}
}




var ur = window.location.href;
if(ur.includes('/product')){
 var omm = 0; var timeromm = setInterval(function(){
  if(jQuery('.button-wrapper.default-cart-button.omnisend-bis-button-container').length) {
	jQuery('h4.freeshipping-text').eq(0).before(jQuery('.button-wrapper.default-cart-button.omnisend-bis-button-container').eq(0))
clearInterval(timeromm);}if( omm > 200){clearInterval(timeromm);}omm++;}, 50); 
}

var ur = window.location.href;
  
jQuery(document).ready(function(){
if(ur.includes('/blog')){
  
 
  if(jQuery('.getsunset-lead-22ybar-container').length == 0){
jQuery('body').append(jQuery('<div class="getsunset-lead-22ybar-container" id="getsunset-lead-22ybar-containerID"> <div class="tailored-sticky-bar"> <a class="getsunset-lead-22ybar-item__copy" href="https://bulletproofzone.com/collections/all?sort_by=best-selling"> <p>Visit our shop and get FREE shipping on orders over $100!</p></a> <span class="tailored-sticky-bar-close"></span></div><div class="getsunset-lead-22ybar-container__outer"> <div class="getsunset-lead-22ybar-container__inner"> <div class="getsunset-lead-22ybar-item__copy"> <p>Visit our shop and get FREE shipping on orders over $100!</p></div><div class="getsunset-lead-22ybar-item_column__button"><a href="https://bulletproofzone.com/collections/all?sort_by=best-selling" class="getsunset-lead-22ybar-item__button" >Shop Now</a></div></div><div class="getsunset-lead-22ybar-closeright-contaier"><div class="getsunset-lead-22ybar-closeright getsunset-lead-exit-close""></div></div></div></div>'));    
  }
function slideShow() {
         jQuery('body').addClass('getsunset-sticky-show');
    
}
function slideHide() {
         jQuery('body').removeClass('getsunset-sticky-show');

    }
  
  jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
     if (y > 300) {
        slideShow();
    } else {
        slideHide();
    }
    
}); 
    
          document.querySelector('.getsunset-lead-22ybar-closeright').onclick = function(e){
         document.querySelector('#getsunset-lead-22ybar-containerID').style.bottom='-500px';
   
};
  
  jQuery(document).ready(function(){
  
 
jQuery('span.tailored-sticky-bar-close').click(function(){
  jQuery('div#getsunset-lead-22ybar-containerID').toggleClass('minimize');
}); 
  
});
                             
}
});
          
jQuery('head').append('<link rel="stylesheet" class="external-css-link" type="text/css" href="https://fonts.googleapis.com/css?family=Montserrat:200, 400,500, 600,700, 900">');






var ur = window.location.href;
if(ur.includes('/product') && window.innerWidth < 768){
  jQuery(document).ready(function(){
jQuery('.product-reviews').eq(0).before(jQuery('.stamped-container').eq(0));
});
   
}


var ur = window.location.href;
if(ur.includes('/blogs')){

jQuery(document).ready(function(){
  if(!jQuery('body').hasClass('nav-loaded')){
  jQuery('body').addClass('nav-loaded')
  
  function add(item, items){
    var unique = true;
    for(var i = 0; i < items.length; i++){
      if(item == items[i]){
       unique = false; 
      }
    }
    if(unique){
     console.log(items.length + ' '  +item);
     items.push(item);
     
    }
    return items;
  }
  var links = jQuery('.product-top-picks span');
  var prodLinks = [];
    
    for(var i = 0; i < links.length; i++){
    var lnk = links.eq(i).attr('product-link') 
    if(prodLinks.length < 3){
        if(lnk.includes('/products')){
         prodLinks = add(lnk, prodLinks);
          console.log('p: ' + i + ' i ' +  prodLinks.length);
        }
    }
  }  
    
  var links = jQuery('.rte a');
  for(var i = 0; i < links.length; i++){
    var lnk = links.eq(i).attr('href') 
    if(prodLinks.length < 3){
        if(lnk.includes('/products')){
         prodLinks = add(lnk, prodLinks);
          console.log('p: ' + i + ' i ' +  prodLinks.length);
        }
    }
  }
    
  
    function isDiffPrices(vars){
      var tempPrice = vars[0]['price']
      for(var i = 1; i < vars.length-1 ; i++){
        console.log(i + " s " + vars.length);
        
        if(tempPrice != vars[i]['price']){
         return true; 
        }
      }
      
      return false
    }


    var x = 0;
    jQuery('.mobile-aside-container .top-pick a').eq(0).attr('href', prodLinks[x]);
    jQuery('.aside-container .top-pick a').eq(0).attr('href', prodLinks[x]);
   
      $.getJSON( prodLinks[0] + ".json", function(data) {
        	 console.log(data);
        console.log(data["product"]["variants"][0]["price"]);
        	if(isDiffPrices(data["product"]["variants"])){
           		jQuery('.aside-container .top-pick .from').eq(0).show();
            }
               
            if(data["product"]["variants"][0]["compare_at_price"] != null){
				jQuery('.aside-container .top-pick .original-price').eq(0).html(data["product"]["variants"][0]["compare_at_price"]);
            }
        
        	jQuery('.aside-container .top-pick .sale').eq(0).html(data["product"]["variants"][0]["price"]);
            
            jQuery('.mobile-aside-container .top-pick img').eq(0).attr('src',data["product"]["image"]["src"]);
            jQuery('.mobile-aside-container .top-pick .pick-name').eq(0).html(data["product"]["title"]);
            jQuery('.aside-container .top-pick img').eq(0).attr('src',data["product"]["image"]["src"]);
            jQuery('.aside-container .top-pick .pick-name').eq(0).html(data["product"]["title"]);

      });
     var x = 1;
    jQuery('.mobile-aside-container .top-pick a').eq(x).attr('href', prodLinks[x]);
    jQuery('.aside-container .top-pick a').eq(x).attr('href', prodLinks[x]);
   
      $.getJSON( prodLinks[1] + ".json", function(data) {
        
           
        	if(isDiffPrices(data["product"]["variants"])){
           		jQuery('.aside-container .top-pick .from').eq(1).show();
            }
               
            if(data["product"]["variants"][0]["compare_at_price"] != null){
				jQuery('.aside-container .top-pick .original-price').eq(1).html(data["product"]["variants"][0]["compare_at_price"]);
            }
        
        	jQuery('.aside-container .top-pick .sale').eq(1).html(data["product"]["variants"][0]["price"]);  
        
            jQuery('.mobile-aside-container .top-pick img').eq(1).attr('src',data["product"]["image"]["src"]);
            jQuery('.mobile-aside-container .top-pick .pick-name').eq(1).html(data["product"]["title"]);
            jQuery('.aside-container .top-pick img').eq(1).attr('src',data["product"]["image"]["src"]);
            jQuery('.aside-container .top-pick .pick-name').eq(1).html(data["product"]["title"]);

      });
     var x = 2;
    jQuery('.mobile-aside-container .top-pick a').eq(x).attr('href', prodLinks[x]);
    jQuery('.aside-container .top-pick a').eq(x).attr('href', prodLinks[x]);
   
      $.getJSON( prodLinks[2] + ".json", function(data) {
        
        
        	if(isDiffPrices(data["product"]["variants"])){
           		jQuery('.aside-container .top-pick .from').eq(2).show();
            }
               
            if(data["product"]["variants"][0]["compare_at_price"] != null){
				jQuery('.aside-container .top-pick .original-price').eq(2).html(data["product"]["variants"][0]["compare_at_price"]);
            }
        
        	jQuery('.aside-container .top-pick .sale').eq(2).html(data["product"]["variants"][0]["price"]);        
            jQuery('.mobile-aside-container .top-pick img').eq(2).attr('src',data["product"]["image"]["src"]);
            jQuery('.mobile-aside-container .top-pick .pick-name').eq(2).html(data["product"]["title"]);
            jQuery('.aside-container .top-pick img').eq(2).attr('src',data["product"]["image"]["src"]);
            jQuery('.aside-container .top-pick .pick-name').eq(2).html(data["product"]["title"]);


      });
    
  
   
  }
  
});

}


var ur = window.location.href;
var isHeaderCart = true;
if(ur.includes('cart') && window.innerWidth < 768){
  isHeaderCart = false;
}
if(isHeaderCart){
var headd = 0; var timerheadd = setInterval(function(){
  if(jQuery("#shopify-section-header").length) {
	


    window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['bfzTopNav3384V2'] = function(){
  if(typeof jQuery !== typeof undefined && jQuery("header.site-header.minimal .logo-contain").length && !jQuery('.bfzTopNav3384V2').length){
    jQuery("body").addClass('bfzTopNav3384V2');
    jQuery("head").prepend('<meta name="viewport" content="width=device-width, initial-scale=1">');
    var winWidth = jQuery(window).width();
    if(winWidth > 700){
      addDesktopChages3384V2();
      jQuery(window).on("scroll resize", function(){
        var promoBar = jQuery(".promo-bar");
        var header = jQuery("#shopify-section-header");
        var main = jQuery("main");
        var scTop = jQuery(window).scrollTop();
        if(scTop > promoBar.outerHeight()){
          header.css({"position": "fixed", "top": 0, "left":0, "right":0, "z-index":991});
          main.css("margin-top", header.outerHeight());
        }
        else{
          header.css({"position": "relative", "top": "auto", "left":"auto", "right":"auto", "z-index":991});
          main.css("margin-top", 0);
        }
      });
      jQuery(window).on("scroll");
    }
    else{
      addMobileChages3384V2();
    }
    addDelightPoints3384V2();
    jQuery(window).on("resize", function(){
      if(jQuery(window).width() != winWidth){
        winWidth = jQuery(window).width();
        checkDeviceWidth3384V2();
      }
    });
  }else{
    window.requestAnimationFrame(bfzTopNav3384V2);
  }
};
window.bfzTopNav3384V2();
function addDesktopChages3384V2(){
  jQuery("body").addClass("template-desktop");
  jQuery(".search-wrapper").appendTo("header.site-header .logo-contain");
  jQuery("header.util div.wrapper > div.right-wrapper").appendTo("header.site-header .logo-contain");
  jQuery(".left-wrapper ul.social-icons + li").appendTo(".left-wrapper ul.social-icons");
  jQuery("header.util .left-wrapper ul.social-icons").appendTo("header.site-header.minimal nav.nav-bar");
}
function addDelightPoints3384V2(){
  if(!jQuery("delightPoints").length){
    htm  ='<div class="delightPoints">';
    htm  +='<ul>';
    htm  +='<li>';
    htm  += `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>`;
    htm  +='<span>Secure Payments</span>';
    htm  +='</li>';
    htm  +='<li>';
    htm  +=`<svg style="margin-right: 5px; width: 26px;height: 26px;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>`;
    htm  +='<span>Free Shipping on Orders Over <strong>$100</strong></span>';
    htm  +='</li>';
    htm  +='<li>';
    htm  +=`
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
    htm  +='<span>Trustpilot Approved</span>';
    htm  +='</li>';
    htm  +='<li>';
    htm  +=`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M23,12l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,12l2.44,2.79l-0.34,3.7 l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,12z M10.09,16.72l-3.8-3.81l1.48-1.48l2.32,2.33 l5.85-5.87l1.48,1.48L10.09,16.72z"/></g></svg>`;
    htm  +='<span>Satisfaction Guaranteed</span>';
    htm  +='</li>';
    htm  +='</ul>';
    htm  +='</div>';
    jQuery("main").prepend(htm);
  }
}
function checkDeviceWidth3384V2(){
  if(jQuery(window).width() <= 700){
    if(jQuery(".template-desktop").length){
      window.location.href = document.URL;
    }
  }
  else{
    if(jQuery(".template-mobile").length){
      window.location.href = document.URL;
    }
  }
}
function addMobileChages3384V2(){
  jQuery("body").addClass("template-mobile");
  jQuery("header.site-header .logo-contain .site-logo").insertAfter("header.util .left-wrapper");
  jQuery("#menu.panel .search").clone().appendTo("header.util div.wrapper");
}
jQuery("body").attr('style', 'visibility:visible !important');


clearInterval(timerheadd);}if( headd > 200){clearInterval(timerheadd);}headd++;}, 50);
  }



console.log('freeshippingbadge');
var ur = window.location.href;
if(ur.includes('/product')){
  $(document).ready(function(){
var aa = 0; var timeraa = setInterval(function(){
  if($('span#CartCount').html().length && $('.bpz-free-shipping').length == 0) {
    
    if($('span#CartCount').html() == "0"){
       var amt = 0;
    }
    else{
       var amt = parseFloat($('span#CartCost span:not(.bold_cart_total)').html().substring(1).replaceAll(',',''));
    }
   
var amtneed = 100-amt;
    amtneed = amtneed.toFixed(2)
    if(amt != 0){
      var amt = $('span#CartCost span:not(.bold_cart_total)').html();
    }
    else{
      var amt = "$0";
      var amtneed = 100;
    }
    
var notfree = 'You have a total of '+amt+' in your cart. <br><span class="progress-texts">Add <b>$'+amtneed+'</b> or more to your cart to get <b>FREE SHIPPING!</b></span>';
  if(amtneed > 0){
    $('.selection-wrapper.price.product-single__price-product-template').after('<div class="bpz-free-shipping no-free"><span>'+notfree+'</span></div>');
    
  }
  else {
    var amt = $('span#CartCost span:not(.bold_cart_total)').html();
    $('.selection-wrapper.price.product-single__price-product-template').after('<div class="bpz-free-shipping"><span>You have '+amt+' worth of items in your cart and qualify for <b>FREE SHIPPING!</b></span></div>');
    
  }	

    $('.sezzle-shopify-info-button').eq(0).after($('.bpz-free-shipping').eq(0));
    
    
    
    
clearInterval(timeraa);}if( aa > 200){clearInterval(timeraa);}aa++;}, 50);
  });
}


var ur = window.location.href;
if (ur.includes("/blog")) {
    $(document).ready(function () {

if(window.innerWidth < 800) {
       
        var ur = window.location.href;
        Element.prototype.appendAfterThis = function (element) {
            element.parentNode.insertBefore(this, element.nextSibling);
        };
        var ctaCopy = "SHOP NOW";
        var ctaLink = "https://bulletproofzone.com/collections/all?sort_by=best-selling" ;
        var stickyCopy = "Visit our shop and get <b>FREE SHIPPING</b> on orders over $100 ";
        var sticky = document.createElement("div");
        sticky.innerHTML =
            `<div class="northeast-slide-st-container" id="northeast-slide-st-containerID"> <div class="affylytics-close"><span>See Offers</span></div><div class="northeast-slide-st-container__outer"> <div class="northeast-slide-st-container__inner"> <div class="northeast-slide-st-item__copy"> ` +
            stickyCopy +
            `</div><div class="northeast-slide-st-item_column__button"> <a href="` +
            ctaLink +
            `" class="northeast-slide-st-item__button" rel="nofollow"> <p>SHOP NOW</p><span></span> </a> </div></div></div></div>`;
        var y = document.getElementsByTagName("body");
        if (document.getElementsByClassName("northeast-slide-st-container").length == 0) {
            y[0].appendChild(sticky);
         
        }
       
        var mc = window.matchMedia("(min-width: 768px)");
        mc.addListener(slideshow);
        function slideshow() {
            if (mc.matches) {
                $("body").addClass("northeastshow");
            } else {
                $("body").addClass("northeastshow");
            }
        }
        function slideHide() {
            $("body").removeClass("northeastshow");
        }
        window.addEventListener("scroll", function (e) {
            var y = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            if ( y> 600) {
                slideshow();
            } 
          else if(window.innerWidth < 768 && y > 800)
            {
                slideshow();
            }
            else {
                slideHide();
            }
        });
      
          function setCookieS(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain";
}
function getCookieS(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function checkCookieS() {
    var counter = getCookieS("CookieSticky");
  console.log(counter);
    if (counter == "") {
    
    }else{
        
      $('.northeast-slide-st-container').addClass('affylytics-hide');  
        
    }
   
}
 checkCookieS();
      $(".affylytics-close").click(function () {
                $("#northeast-slide-st-containerID").toggleClass("affylytics-hide");
                console.log("test");
                       if($('.northeast-slide-st-container').hasClass('affylytics-hide'))
                  {
                          setCookieS("CookieSticky", 1, 1);
                      
                  }else{
                        setCookieS("CookieSticky", "", 1);
                      
                      
                  }
            });
}

       });
   
  }




var ur = window.location.href;
if(ur.includes('/product')){
$(document).ready(function(){
if(window.innerWidth < 768) {
     setTimeout(function(){ 


 $("span.badge2").html($("span.badge2").html().replace("Secure Payments", "Price Match Guarantee"));
  $('.bulletproof-badge-container svg').eq(2).remove();
  if($('.bulletproof-badge-container img').length == 0){
  $('.bulletproof-badge-container').eq(2).prepend($('<img src="https://cdn.shopify.com/s/files/1/1926/7025/files/bulletproof-pricematch_2.png?v=1664249452">'));  
  }
       
  
 var atc = 0; var timeratc = setInterval(function(){
  if($('.simple-badges').length == 0) {
  
      
    $('body').append($(`<div class="simple-popup simple-shipping-popup"> <div class="popup-content"> <div class="popup-title">Shipping and Delivery <span class="simple-close">×</span></div><div class="popup-p"><div class="popup-contentt"><div id="tab-2" class="tab-content current"> <meta charset="utf-8"> <p>Bulletproof Zone will ship orders as soon as possible. For example, if you purchase three items, they will be shipped to you based on lead time and availability.&nbsp;This way you get as much of your order as soon as possible, which means that your order may come in separate packages, especially if you order products from different manufacturers.</p><p>We will bear the shipping cost for products returned because of product defect, misrepresentation, or false description. Afterward, we will initiate a full reimbursement should you decline an offer to replace the item with the same item of equal value and assured quality.</p><p><strong>Order Confirmation:</strong></p><p>As soon as you place your order with Bulletproof Zone, you will receive an order confirmation e-mail. This means that your order has been logged in our system and your credit card has been pre-authorized for the purchase. Afterward, we contact our suppliers to confirm the availability of the product you are ordering for immediate shipment. If your item is on backorder or unavailable, we will cancel the pre-authorization and duly inform you via e-mail.</p><p><strong>Order Shipment:</strong></p><p>Orders are shipped within five business days from the date of your order <strong>unless specified otherwise on the product page</strong>. The product page will contain the most accurate&nbsp;estimate on shipping and lead times. Shipping and lead times provided on the product page are our best estimates based various factors including order volume, information from our manufacturer, raw material fluctuations, etc., and may vary due to these factors.&nbsp;</p><p>You will receive an email containing the tracking information of your order after the order has been shipped to your location. If you do not receive tracking information from us within seven business days of the lead time <strong>specified on the product page</strong>, feel free to follow up with us at orders@bulletproofzone.com.</p><p><strong>Damages:</strong></p><p>We take full responsibility for any obvious damage to your product caused by wrong packaging or delivering an already defective product. Please inspect the packaging of your item(s) when they arrive, if you notice any damage, you should document it when signing for delivery. If the item(s) contained in the package arrives damaged, please send photos to support@bulletproofzone.com, and we will process an insurance claim on your behalf.&nbsp;</p></div></div></div></div></div>`))
 $('body').append($(`<div class="simple-popup simple-payment-popup"> <div class="popup-content"> <div class="popup-title">Price Match Guarantee <span class="simple-close">×</span></div><div class="popup-p"> <div class="popup-contentt"><div id="tab-3" class="tab-content current"> <meta charset="utf-8"><meta charset="utf-8"><p><strong>Price Guarantee </strong></p><p>At Bulletproof Zone, we ensure that you get the absolute best prices for Bulletproof Vests, Plate Carriers,&nbsp;Bulletproof Clothing, Bulletproof Backpacks, as well as other tactical gear and safety products, all while ensuring the highest quality.</p><p>For us, providing products of the highest quality is unnegotiable. As always, high-quality products do not come cheap, but we ensure that it is reasonably priced using our exclusive contracts with the best protective product manufacturers.</p><p>We want you to feel confident that you are getting the absolute best price for the product you are ordering. To show our confidence in our prices, we offer a price guarantee to our customers. If you find out within six months from your purchase of an item that our company offered an item for a price higher than our competition, we will refund the difference.&nbsp;</p><p>To get a refund, all you need to do is e-mail us a link to the product on our website and the same product on our competitor’s website within six months from the date of your purchase, and we will process the refund accordingly.</p><p><strong>Terms and Conditions of our 100% Price Guarantee:</strong></p><ul><li>You must have purchased the item from our website before requesting your Price Match Guarantee</li><li>Discounted goods and goods received as an Ad on such as; buy one, get one free offer are not eligible</li><li>The item must be in stock on the competitor's website</li><li>The 100% price guarantee is only valid within the first six months from the date of purchase</li><li>The competitor must be an online store; they may not have a retail location</li><li>The competitor website cannot be a discounter or an auction website (i.e., eBay, overstock, etc.)</li><li>The competitor must be an Authorized Retailer of the product in question</li><li>The Price Match Guarantee includes the item price and the shipping charges; it excludes sales tax</li></ul><ul></ul></div></div></div></div></div>`))
 $('body').append($(`<div class="simple-popup simple-return-popup"> <div class="popup-content"> <div class="popup-title">Easy Returns<span class="simple-close">×</span></div><div class="popup-p"> <div class="popup-contentt"> <div id="tab-2" class="tab-content current"> <meta charset="utf-8"><p><strong>Returns and Cancellation Policy:</strong></p><p><strong></strong>We back all our products with a customer satisfaction guarantee, so we created a fair return and cancellation policy.</p><p><strong>All sales are final. No Refunds, No Cancellations.</strong> In most cases, once the order is processed, it is final and not cancellable. We may allow exceptions due to an order error or wish to return your order after delivery for any reason other than a product defect or misrepresentation. Any cancellation request is subject to an administration and cancellation fee equal to 10% of your order with a minimum of $35, whether order shipment is successful or not.</p><p>All sales are final on all closeout items and for custom manufactured bulletproof clothing once the manufacturing process has begun or not returnable unless there is a product defect or misrepresentation. Applicable to brands such as MC Armor, Israel Catalog, Masada Armor, BulletBlocker, Tread Armament, Talos Ballistics, Wonder Hoodie, and others.&nbsp;</p><p>Before returning any product, you MUST obtain a return authorization from our customer service representative. We can only process AUTHORIZED returns for items.</p><p><strong>To make a Return or Exchanges:</strong>&nbsp;</p><ul><li>Obtain authorization for return or exchange by emailing us at <a href="mailto:support@bulletproofzone.com">support@bulletproofzone.com</a> explaining the reason for the return or exchange.</li><li>Please use or indicate your order number as attention</li></ul><p>Return or exchanges request submission must be within 14 calendar days upon receipt of shipment unless noted otherwise on the product description page.&nbsp; Your return must be in original packaging and unused.</p><p>We encourage using USPS flat-rate shipping in returning products to receive a shipping expense refund. Buyers must ensure all returned parcels delivery receipt AND signature confirmation. We highly recommend insuring your parcel as we cannot issue a refund for an item that we do not receive back should it get lost/damaged during transit.</p><p><strong>Refunds:</strong></p><p>Should an item be returned because it was defective, misrepresented, not as described, etc., Bulletproof Zone will issue a full refund and will reimburse the customer for all shipping expenses associated with the return.</p><p>Please allow 5-10 business days from the time the item is received to process a refund. Refunds will only be issued to the original credit card that you use when placing your order.</p><p>We stand behind our products 100%!</p><p>By purchasing any of our items, the buyer certifies they have read and agree to our shipping, return, and privacy policies.</p></div></div></div></div></div>`))
    
  $('.bulletproof-badges-container').eq(0).click(function(e){
  e.stopPropagation();
  $('.simple-shipping-popup').eq(0).addClass('open')
console.log('testing')
  });   
  
        $('.bulletproof-badges-container').eq(2).click(function(e){
  e.stopPropagation();
  $('.simple-payment-popup').eq(0).addClass('open')
  });   
 $('span.simple-close').click(function(){
  $(this).parent().parent().parent().removeClass('open')
});
    
            $('.bulletproof-badges-container').eq(3).click(function(e){
  e.stopPropagation();
  $('.simple-return-popup').eq(0).addClass('open')
  });   
 $('span.simple-close').click(function(){
  $(this).parent().parent().parent().removeClass('open')
}); 
    
    $('.simple-popup').click(function(event){
  event.stopPropagation();
});
   $(window).click(function() {
     if($('body > .open').length){
       $('span.simple-close').click();
     }
  
});
clearInterval(timeratc);}if( atc > 200){clearInterval(timeratc);}atc++;}, 50);
       }, 500);
}


});  
}




var ur = window.location.href;
if(ur.includes('/product') && $('.about-us-section-container').length == 0 && window.innerWidth > 768){
  $(document).ready(function(){
    
$(".single-product .grid").eq(0).after($('<div class="about-us-section-container"><div class="about-us-section-inner"><div class="ttle">WHY BULLETPROOF ZONE</div><p>At Bulletproof Zone, we are passionate about protecting and saving lives. We’ve partnered with the best brands under a strict set of guidelines and offer the highest quality body armor and safety equipment available on the market.</p><p>Whether you are a professional already familiar with body armor, or a normal civilian just looking to protect yourself, our gear and equipment will provide you with the protection and security you can trust.</p><p>Any questions or concerns? Please call us at <a href="tel:(408)-909-4938">(408)-909-4938</a> or email us at <a href="mailto:support@bulletproofzone.com">support@bulletproofzone.com</a> and a member of our professional support team will be in touch with you as soon as possible.</p></div></div>'))
});
}


var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
var ntt = 0; var timerntt = setInterval(function(){
  if(jQuery('a.btn.klaviyo-bis-trigger').length) {
	jQuery('button#AddToCart-product-template.disabled').before(jQuery('a.btn.klaviyo-bis-trigger').eq(0))
clearInterval(timerntt);}if( ntt > 500){clearInterval(timerntt);}ntt++;}, 50);
}); 
}

var ur = window.location.href;
if(ur.includes('/blog')){
  jQuery(document).ready(function(){
$('.rte a').removeAttr('target')

 let rteElement = $(".rte").first();
    let content = rteElement.html();
    if (content.includes("(Updated")) {
        let parts = content.split("(Updated");
        let firstPart = parts[0];
        let secondPart = parts[1].split(")")[1];
        let updatedContent = firstPart + "(Updated " + getCurrentMonthYear() + ")" + secondPart;
        rteElement.html(updatedContent);
    }
    else{
      $(".rte").eq(0).prepend($('<p>(Updated '+getCurrentMonthYear() +')</p>'));
    }

    function getCurrentMonthYear() {
        const date = new Date();
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return month + ' ' + year;
    }
});
}


var cc = 0; var timercc = setInterval(function(){
  if(jQuery('.trustedsite-trustmark.cart-drawer-trusted.loaded').length && $('#cart-drawer-container .bottom-section').length) {
	$('#cart-drawer-container .bottom-section').eq(0).append(jQuery('.trustedsite-trustmark.cart-drawer-trusted').eq(0));
clearInterval(timercc);}if( cc > 200){clearInterval(timercc);}cc++;}, 50);